import React, { useEffect } from 'react'
import styles from './styles.module.css'
import Button from '../../../components/Button'
import { useDispatch, useSelector } from 'react-redux'
import { useFormik } from 'formik'
import { Input, Select, Textarea } from '../../../components/ModalInputs'
import { createSchoolWeek, deleteSchoolWeek, updateSchoolWeek } from '../../../actions/schoolWeeks'
import * as Yup from 'yup'
import ModalFooter from '../../../components/ModalFooter/ModalFooter'
import { getCurrentTermUtils, getCurrentYearUtils } from '../../../utils/classBook'
import { getStudyPeriod } from '../../../actions/classbook'
import { getScheduleVariantsDO } from '../../../actions/doScheduleVariants'
import { getScheduleVariantsVD } from '../../../actions/vdScheduleVariants'
import { getScheduleVariantsList } from '../../../actions/scheduleVariants'


const validationSchema = Yup.object({
  week_name: Yup.string().required('обязательное поле'),
  wstart_date: Yup.string().required('обязательное поле'),
  wend_date: Yup.string().required('обязательное поле')
})


export default function Main({ closeModal, data, addMode, params, onSuccess }) {
  console.log('params::: ', params);

  const dispatch = useDispatch()
  const { loading } = useSelector(state => state.school_weeks)
  const { studyPeriod } = useSelector(state => state.classbook)
  const { schoolYears } = useSelector(state => state.common)
  const { list: do_sh } = useSelector(state => state.do_schedule_variants)
  const { list: vd_sh } = useSelector(state => state.vd_schedule_variants)
  const { list: reg_sh } = useSelector(state => state.schedule_variants)

  const handleCreateWeek = async (values) => {
    await dispatch(createSchoolWeek(values, params))
    onSuccess?.()
    closeModal()
  }

  const handleUpdateWeek = async (values) => {
    const { week_id, ...payload } = values
    await dispatch(updateSchoolWeek(week_id, payload, params))
    onSuccess?.()
    closeModal()
  }

  const {
    values,
    errors,
    touched,
    submitCount,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue
  } = useFormik({
    initialValues: addMode ? {} : data,
    enableReinitialize: true,
    validateOnChange: true,
    validationSchema: validationSchema,
    onSubmit: addMode ? handleCreateWeek : handleUpdateWeek,

  })

  useEffect(() => {
    if (values.wstart_date) {
      const trmid_list = getCurrentTermUtils(studyPeriod, (values.wstart_date))
      console.log('values.wstart_date::: ', values.wstart_date);
      console.log('studyPeriod::: ', studyPeriod);
      console.log('trmid_list::: ', trmid_list);
      setFieldValue('trmid_list', !!trmid_list ? [trmid_list] : [])
    }
  }, [values.wstart_date])

  useEffect(() => {
    if (!params.scYear) return
    dispatch(getScheduleVariantsDO(params.scYear))
    dispatch(getScheduleVariantsVD(params.scYear))
    dispatch(getScheduleVariantsList(params.scYear))
    dispatch(getStudyPeriod(params))
  }, [])

  const error = (fieldName) => (touched[fieldName] || submitCount) && errors[fieldName]
  return (
    <>
      <div className={styles.modalMain}>
        <div className={styles.tabWrapper}>
          <div className={styles.inputsRow}>
            <Input
              label='Название'
              name='week_name'
              value={values.week_name}
              error={error('week_name')}
              onChange={handleChange}
              onBlur={handleBlur}
            />
          </div>
          <div className={styles.inputsRow}>
            <Input
              label='Период (начало)'
              name='wstart_date'
              type='date'
              value={values.wstart_date}
              error={error('wstart_date')}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            <Input
              label='Период (конец)'
              name='wend_date'
              type='date'
              value={values.wend_date}
              onChange={handleChange}
              error={error('wend_date')}
              onBlur={handleBlur}
            />
          </div>
          <div className={styles.inputsRow}>
            <Textarea
              style={{ resize: 'none', width: '750px', height: '100px' }}
              label='Комментарий'
              value={values.week_comment}
              onChange={handleChange}
              name='week_comment'
            />
          </div>
          <Select
            label="Учебный период"
            name={"sh_var_id"}
            value={values.sh_var_id}
            withoutArrowMode
            onChange={handleChange}
          >
            <option value='0' >Выбрать</option>
            {studyPeriod &&
              studyPeriod?.map(el => <option key={el.trmid || el.xp_key} value={el.trmid || el.xp_key}>{el.name || el.title}</option>
              )}
          </Select>
          <Select
            label="Вариант расписания"
            name={"pers_sh_var_id"}
            value={values.pers_sh_var_id}
            withoutArrowMode
            onChange={handleChange}
          >
            <option value='0' >Выбрать</option>
            {reg_sh &&
              reg_sh?.map(el => <option key={el.sh_var_id || el.xp_key} value={el.sh_var_id || el.xp_key}>{el.sh_var_name || el.title}</option>
              )}
          </Select>
          <Select
            label="Вариант расписания доп. образования"
            name={"do_sh_var_id"}
            value={values.do_sh_var_id}
            withoutArrowMode
            onChange={handleChange}
          >
            <option value='0' >Выбрать</option>
            {do_sh &&
              do_sh.slice(0, 10).map(el => <option key={el.sh_var_id || el.s_year_id} value={el.sh_var_id || el.s_year_id}>{el.sh_var_name || el.title}</option>
              )}
          </Select>
          <Select
            label="Вариант расписания внеур. деятельности"
            name={"out_sh_var_id"}
            value={values.out_sh_var_id}
            withoutArrowMode
            onChange={handleChange}
          >
            <option value='0' >Выбрать</option>
            {vd_sh &&
              vd_sh?.slice(0, 10).map(el => <option key={el.sh_var_id || el.xp_key} value={el.sh_var_id || el.xp_key}>{el.sh_var_name || el.title}</option>
              )}
          </Select>
        </div>
      </div>
      <ModalFooter handleSubmit={handleSubmit} closeModal={closeModal} />
    </>
  )
}
